import { createIcon } from './createIcon';

/** Stacked blocks — the catalog of apps & skills. */
export const SkillsIcon = createIcon({
  name: 'SkillsIcon',
  viewBox: '0 0 20 20',
  size: 16,
  color: 'var(--text-secondary)',
  children: (
    <>
      <rect
        x="3"
        y="3"
        width="6"
        height="6"
        rx="1.4"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <rect
        x="11"
        y="3"
        width="6"
        height="6"
        rx="1.4"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <rect
        x="3"
        y="11"
        width="6"
        height="6"
        rx="1.4"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <rect
        x="11"
        y="11"
        width="6"
        height="6"
        rx="1.4"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </>
  ),
});

export default SkillsIcon;
